export default __webpack_public_path__ + "static/media/phase1_end.2378e10d.png";